import {
  PERFILES_GET_ROLES_BEGIN,
  PERFILES_GET_ROLES_SUCCESS,
  PERFILES_GET_ROLES_FAILURE,
  PERFILES_GET_ROLES_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getRoles(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PERFILES_GET_ROLES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/roles/getAllforRolesList" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            const roles = res.data.data;
            roles.forEach((role) => {
              role['activedUsers'] = role.userCount;
              role.Functions_Modules.forEach((function_module) => {
                function_module['function_id'] = function_module.Function.id;
                function_module['function_name'] = function_module.Function.name;
                function_module['module_id'] = function_module.Module.id;
                function_module['module_name'] = function_module.Module.name;
              });
            });
            dispatch({
              type: PERFILES_GET_ROLES_SUCCESS,
              data: roles,
              pagination: res.data.pagination
            });
            resolve(res);
          } else {
            dispatch({
              type: PERFILES_GET_ROLES_FAILURE,
              data: [],
            });
            reject();
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERFILES_GET_ROLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetRolesError() {
  return {
    type: PERFILES_GET_ROLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERFILES_GET_ROLES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getRolesPending: true,
        getRolesError: null,
      };

    case PERFILES_GET_ROLES_SUCCESS:
      // The request is success
      return {
        ...state,
        getRolesPending: false,
        getRolesError: null,
        roleList: [...action.data],
        rolesPagination: { ...action.pagination }
      };

    case PERFILES_GET_ROLES_FAILURE:
      // The request is failed
      return {
        ...state,
        getRolesPending: false,
        getRolesError: action.data.error,
      };

    case PERFILES_GET_ROLES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getRolesError: null,
      };

    default:
      return state;
  }
}
